<template>
  <BaseDataTable
    v-if="documents.length > 0"
    :headers="activeHeaders"
    :items="documents"
    hide-default-footer
    class="document-data-table"
  >
    <template v-slot:item="{ item }">
      <tr>
        <td>
          <div class="d-flex">
            <v-icon class="primary--text pr-4 icon-size">fa-file-pdf</v-icon>
            <span class="truncate">{{ nameFile(item) }}</span>
          </div>
        </td>
        <td width="30%">
          <div class="d-flex justify-end">
            <BaseButton
              color="secondary"
              class="base-input-file__button button-size mr-2 px-0"
              @click="$emit('preview-file', item)"
              v-if="viewButton"
            >
              <img class="img-size" :src="require('@/assets/ic_eye.svg')" />
            </BaseButton>
            <BaseButton
              color="secondary"
              class="base-input-file__button button-size px-0"
              @click="$emit('remove-file', item)"
              v-if="deleteButton && !disabled"
            >
              <img class="img-size" :src="require('@/assets/ic_trash.svg')" />
            </BaseButton>
          </div>
        </td>
      </tr>
    </template>
  </BaseDataTable>
</template>

<script>
const tableHeaders = [
  { text: "Documento anexado", value: "arquivo.nome", sortable: false },
  { text: "Ações", value: "actions", sortable: false }
];

const emptyHeader = {
  text: "",
  value: "",
  sortable: false
};

export default {
  name: "DocumentDataTable",
  data() {
    return {
      tableHeaders,
      emptyHeader
    };
  },
  computed: {
    activeHeaders() {
      if (this.viewButton || (this.deleteButton && !this.disabled)) {
        return tableHeaders;
      }

      return [tableHeaders[0], emptyHeader];
    }
  },
  methods: {
    nameFile(item) {
      return (item.arquivo && item.arquivo.nome) || item.nome;
    }
  },
  props: {
    documents: { type: Array },
    deleteButton: {
      type: Boolean,
      default: true
    },
    viewButton: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="sass">
.document-data-table
  thead tr th:last-child
    text-align: end !important
</style>
